<template>
    <b-col>
        <!-- {{action}} -->
        <b-row>
            <b-dropdown :text="actionDescription">
                <template v-for="(actions,parser) in parserActions">
                    <b-dropdown-group class="dropdown-header" v-if="parser==='BaseParser' || parser === parserName" :key="parser" :header="parser">
                        <b-dropdown-item v-for="(act,index) in actions" :key="index+'-'+action.action+'-change-action-dropdown'" @click="changeAction(act)">{{act.text}}</b-dropdown-item>
                    </b-dropdown-group>
                </template>
            </b-dropdown>
        </b-row>
        <b-row>&nbsp;</b-row>
        <b-row>
            <b-col>
                <b-form-checkbox :id="_uid+'conditioncheck'" v-model="conditionCheck" @change="conditionCheckChanged">Condition</b-form-checkbox>
                <template v-if="conditionCheck">
                    <b-dropdown variant="outline-light" :text="action.condition.key==='' ? 'Select condition key'  : action.condition.key">
                        <b-dropdown-item v-for="(key,index) in metadataKeys" :key="'condition'+index" @click="setCondition('key',key)">{{key}}</b-dropdown-item>
                    </b-dropdown>
                    <b-form-checkbox :id="_uid+'conditionisfalsecheck'" v-model="action.condition.is_false" @change="setCondition('is_false',!action.condition.is_false)">Is false</b-form-checkbox>
                </template>
            </b-col>
        </b-row>
        
        <b-row>
            <b-col v-for="(field,key) in actionFields" :key="key+'-actionline-'+field[0]">
                <template v-if="field[0]=='from_metadata_key'">
                    <base-input :label="field[1]" :placeholder="field[1]" type="text" v-model="action.params.from_metadata_key" @input="validate(key)"></base-input>
                    <b-dropdown variant="outline-light" text="Key choices">
                        <b-dropdown-item @click="setParam('from_metadata_key',null)">User input</b-dropdown-item>
                        <b-dropdown-item v-for="(mk,index) in metadataKeys" :key="'mk'+index" @click="setParam('from_metadata_key',mk)">{{mk}}</b-dropdown-item>
                    </b-dropdown>
                </template>
                <template v-else-if="field[0]=='value_input_str'">
                    <base-input :label="field[1]" :placeholder="field[1]" type="text" v-model="action.params[key]" @input="validate(key)"></base-input>
                </template>
                <template v-else-if="field[0]=='value_input_num'">
                    <base-input :label="field[1]" :placeholder="field[1]" type="number" v-model.number="action.params[key]" @input="validate(key)"></base-input>
                </template>
                <template v-else-if="field[0]=='value_input_bool'">
                    <b-col>
                        <p>&nbsp;</p>
                        <b-form-checkbox :id="_uid+key" v-model="action.params[key]">{{field[1]}}</b-form-checkbox>
                    </b-col>
                </template>
                <template v-else-if="field[0]=='value_input'">
                    <base-input label="Value type">
                        <b-dropdown variant="outline-light" label="Value type" :text="valueInputTypes[key]">
                            <b-dropdown-item @click="changeValueInputType(key,'text')">text</b-dropdown-item>
                            <b-dropdown-item @click="changeValueInputType(key,'number')">number</b-dropdown-item>
                            <b-dropdown-item @click="changeValueInputType(key,'checkbox')">boolean</b-dropdown-item>
                        </b-dropdown>
                    </base-input>
                    
                    <base-input v-if="valueInputTypes[key]=='number'" :label="field[1]" :type="valueInputTypes[key]" placeholder="Value" v-model.number="action.params[key]" @input="validate(key)" />
                    <base-input v-else-if="valueInputTypes[key]=='text'" :label="field[1]" :type="valueInputTypes[key]" placeholder="Value" v-model="action.params[key]" @input="validate(key)" />
                    <b-form-checkbox v-else v-model="action.params[key]" :label="field[1]" :id="_uid+key+'_booleaninput'" @change="validate(key)">Value</b-form-checkbox> <!--Checkbox change eventi burada istenildiği gibi çalışmayabilir, test et -->
                </template>
                <template v-else-if="field[0]=='value_input_choices'">
                    <b-col>
                        <base-input :label="field[1]">
                            <b-dropdown variant="outline-light" :label="field[1]" :text="action.params[key]===null || action.params[key]===undefined ? 'Not selected' : field[4][0][action.params[key]]">
                                <b-dropdown-item v-for="(choiceDescription,choice) in field[4][0]" :key="`vfc-${key}-${choice}-${choiceDescription}`" @click="setParam(key,choice)">{{choiceDescription}}</b-dropdown-item>
                            </b-dropdown>
                        </base-input>
                    </b-col>
                </template>
                <template v-else-if="field[0]=='value_input_list'"> <!-- Burası için farklı tip validasyonlar yazılmalı -->
                    <b-col>
                        <list-editor :paramKey="key" :data="action.params[key]" :label="field[1]" @change="listChanged" :dataMappings="field[4][0]" />
                    </b-col>
                </template>
                <template v-else-if="field[0]=='value_input_map'">
                    <b-col>
                        <h5>{{field[1]}}</h5>
                        <json-editor :data="action.params[key]" :paramKey="key" @change="mapChanged" />
                    </b-col>
                    <b-col></b-col>
                </template>
                <template v-else-if="field[0]=='type_input'">
                    <b-dropdown variant="outline-light" text="Type">
                        <b-dropdown-item-button @click="setParam(key,null)">Don't convert</b-dropdown-item-button>
                        <b-dropdown-item-button @click="setParam(key,'str')">String</b-dropdown-item-button>
                        <b-dropdown-item-button @click="setParam(key,'int')">Integer</b-dropdown-item-button>
                        <b-dropdown-item-button @click="setParam(key,'float')">Float</b-dropdown-item-button>
                        <b-dropdown-item-button @click="setParam(key,'bool')">Boolean</b-dropdown-item-button>
                    </b-dropdown>
                    <h5>Selected : {{action.params[key]}}</h5>
                </template>
                <template v-else-if="field[0]=='to_metadata_key'">
                    <base-input :label="field[1]" :placeholder="field[1]" type="text" v-model="action.params.to_metadata_key" @input="validate(key)"></base-input>
                </template>
                <template v-else-if="field[0]=='to_data_key'">
                    <base-input :label="field[1]" :placeholder="field[1]" type="text" v-model="action.params.to_data_key" @input="validate(key)"></base-input>
                    <b-dropdown variant="outline-light" text="Key choices">
                        <b-dropdown-item @click="setParam('to_data_key',null)">User input</b-dropdown-item>
                        <b-dropdown-item v-for="(kwargKey,index) in keywordArgs" :key="'kwarg-'+index" @click="setParam('to_data_key',kwargKey)">{{kwargKey}}</b-dropdown-item>
                    </b-dropdown>
                </template>
                <template v-if="validationErrors[key]!==undefined">
                    <ul>
                        <li v-for="(error,index) in validationErrors[key]" :key="key+'error-'+index" class="validation-error">{{error}}</li>
                    </ul>
                </template>
            </b-col>
        </b-row>

    </b-col>
<!-- TODO: Parser fonksiyonunu listeye ekleme yapabilecek şekilde düzenlediğinde listeye ekle checkbox'ı koy. -->
</template>

<script>
import JSONEditor from '@/components/JSONEditor.vue';
import ListEditor from '@/components/ListEditor.vue';

export default {
    name:'action',
    components:{
        [JSONEditor.name]:JSONEditor,
        [ListEditor.name]:ListEditor,
    },
    props:{
        action:Object,
        parserName:String,
        metadataKeys:Array,
    },
    data(){
        return {
            // Bu iki değişkenin tanımlamasını created'a aldım. İçerisinde buradaki değişkenlere referans olması sorun çıkarıyorduç
            parserActions:null,
            actionFieldRelations:null,

            actionDescription:'Select action',

            conditionCheck:false, // Action bir kondisyona bağlı olarak çalışacaksa true gelir.

            actionFields:{}, // Action'daki field'lar.
            valueInputTypes:{}, // Inputların tiplerini tutar. (value_input için)
            inputTypes:{ // Input tipleri (value_input)
                number:'number',
                string:'text',
                boolean:'checkbox'
            },
            inputToValueTypes:{ // value_input tipi değiştiğinde gerekli tip değişimleri
                'text':String,
                'number':Number,
                'checkbox':Boolean,
            },

            listInputs:{}, // Listeye eklemek için kullanılan inputların değerlerini tutar.

            conditionInputs:{},
            validationErrors:{},

            caseInsensitiveListInputMappings:{
                'value':['text','Value'],
                'case_insensitive':['checkbox','Case insensitive ?'],
            },

            paginateChoices:{
                'url_query':'URL Query parameter',
                'url_endpoint':'URL Endpoint',
                'json_body':'JSON Body',
            },
            geocodeMethodChoices:{
                'google':'Google',
                'here':'Here',
                'hk_gov':'Hong Kong gov. API',
                'onemap':'One map',
                'baidu':'Baidu',
            },

            keywordArgs:[
                'urls',
                'results',
                'splitter_items',
                'next_iter_params',
            ],
        }
    },
    created(){
        this.defineActions();
        if(!(['',undefined,null].includes(this.action.action)))
            this.setAction();
    },
    watch:{
        action: function(val) {
            this.setAction();
        }
    },
    methods:{
        setAction(){
            this.metadataKeys=[...new Set(this.metadataKeys.filter(function(val) { return val!==null && val!==''; }))]; // Duplicate'leri ve null'ları temizler.
            this.actionFields=this.actionFieldRelations[this.action.action];

            this.setActionDescription();

            if(this.action.condition!==undefined)
                this.conditionCheck=true;
            else
                this.conditionCheck=false;
            
            for(var key in this.actionFields){
                var field=this.actionFields[key];
                if(field[0]=='value_input'){ // value_input olan fieldların tip kayıtlarının tutulacağı obje oluşturuldu
                    if(this.action.params[key]!==undefined)
                        this.valueInputTypes[key]=this.inputTypes[typeof this.action.params[key]];
                    else
                        this.valueInputTypes[key]='text';
                }
                else if(field[0]=='value_input_list' && this.action.params[key]===undefined) // Liste inputu alan ve tanımlanmamış olanlar için tanımlama
                    this.action.params[key]=[];
                
                this.runValidations(key);
            }
            this.$forceUpdate();
        },
        setActionDescription(){
            for(var i in this.parserActions){
                for(var j in this.parserActions[i]){
                    if(this.parserActions[i][j].action==this.action.action){
                        this.actionDescription=this.parserActions[i][j].text;
                        return;
                    }
                }
            }

            this.actionDescription='Select action';
        },
        changeAction(act){
            this.action.action=act.action;
            this.action.params={}
            this.setAction();
        },
        addToList(key){
            this.action.params[key].push(this.listInputs[key]);
            this.listInputs[key]='';
        },
        removeFromList(key,index){
            this.action.params[key].splice(index,1);
            this.$forceUpdate()
        },
        // Pre-validate
        deleteBlankValidation(key){
            if(this.action.params[key]==='')
                delete this.action.params[key];
        },
        // Validate
        notBlankValidation(key){
            if(this.action.params[key]===undefined || this.action.params[key]===null || (this.action.params[key]=='' && this.action.params[key]!==0))
                return 'This field cannot be blank'
            return true
        },
        changeValueInputType(key,type){
            this.valueInputTypes[key]=type;
            if(this.action.params[key]!==null && this.action.params[key]!==undefined && (this.action.params[key]!=='')){
                this.action.params[key]=this.inputToValueTypes[type](this.action.params[key]);
            }
            this.$forceUpdate();
        },
        validate(key){ // TODO: map input ve list inputlar için validasyon ?
            this.$emit('change','getMetadataKeys');
            delete this.validationErrors[key];

            for(var i in this.actionFields[key][2]){ // İşlem
                this.actionFields[key][2][i](key); // Bunlardan return değeri almamıza gerek yok.
            }
            this.$forceUpdate();

            return this.runValidations(key);
        },
        runValidations(key){
            var errors=[];
            for(var i in this.actionFields[key][3]){ // Validasyon
                var validationFunc=this.actionFields[key][3][i]
                var result=validationFunc(key)
                // Validasyon fonksiyonlarının return değerleri true veya string.
                // if(!result) çalışmaz.
                if(!(result==true)){
                    errors.push(result)
                }
            }

            this.validationErrors[key]=errors;
            this.$forceUpdate();
            
            return errors.length>0;
        },
        mapChanged(mapData){
            var data=mapData[0];
            var paramKey=mapData[1];
            this.action.params[paramKey]=data;
            this.$forceUpdate();
        },
        listChanged(listData){
            var data=listData[0];
            var paramKey=listData[1];
            this.action.params[paramKey]=data;
            this.$forceUpdate();
        },
        conditionCheckChanged(val){
            if(!val)
                delete this.action.condition;
            else
                this.action.condition={key:'',is_false:false}
        },
        setParam(key,val){
            if(val===null)
                delete this.action.params[key];
            else
                this.action.params[key]=val;
            
            this.validate(key)
            this.$forceUpdate();
        },
        setCondition(key,val){
            this.action.condition[key]=val;
            this.$forceUpdate();
        },
        defineActions(){
            this.parserActions={
                BaseParser:[
                    {action:'add_to_metadata',text:'Add to metadata'},
                    {action:'add_to_data',text:'Add to data'},
                    {action:'get_indexed_metadata',text:'Get indexed metadata'},
                    {action:'add_to_data_from_metadata',text:'Add to data from metadata'},
                    {action:'get_saved_metadata',text:'Get saved metadata'},
                    {action:'split_string',text:'Split string'},
                    {action:'sub_string',text:'Sub String'},
                    {action:'replace_string',text:'Replace string'},
                    {action:'clear_text',text:'Clear text'},
                    {action:'get_length',text:'Get length'},
                    {action:'join_string',text:'Join string'},
                    {action:'clear_duplicates',text:'Clear duplicates'},
                    {action:'parse_js',text:'Parse JavaScript'},
                    {action:'lat_lon_from_googlemaps_url',text:'Coordinates from Google Maps URL'},
                    {action:'get_kml',text:'Get KML'},
                    {action:'geocode',text:'Geocode'},
                    {action:'url_encode',text:'URL encode'},
                    {action:'url_decode',text:'URL decode'},
                    {action:'cross_join',text:'Cross join'},
                    {action:'paginate_links',text:'Paginate URLs'},
                    {action:'sleep',text:'Sleep'}
                ],
                SoupParser:[
                    {action:'get_with_css_selector',text:'CSS selector'},
                    {action:'get_items_with_css_selector',text:'Get items with CSS selector'},
                ],
                JSONParser:[
                    {action:'get_json_field',text:'Get JSON field'},
                    {action:'get_items_from_json_list',text:'Get items from JSON list'},
                    {action:'get_json_values',text:'Get JSON values'},
                    {action:'get_json_keys',text:'Get JSON keys'},
                ],
            },
            
            this.actionFieldRelations={
                // Fieldların hangi action'larda olduğunu belirtir, sıralamaya göre basar.
                // Validation: Her field 2 farklı liste alır: birinci liste change'den sonra çalışacak fonksiyonları, ikinci liste
                // ise validation için kullanılacak fonksiyonları içerir. Her değişimde önce birinci liste, sonra ikinci liste 
                // içerisindeki fonksiyonlar çalışır. Her iki listedeki fonksiyonlar parametre adını (key) alır.
                // Validation fonksiyonu true döndürürse valid veri var demektir.
                // Onun dışındaki değerler hatayı döndürür.
                
                add_to_metadata:{
                    value:['value_input','Value',[],[this.notBlankValidation]], // Herhangi bir tipte input alabilir
                    eval:['value_input_bool','Evaluate input',[],[]],
                    type:['type_input','Value type',[],[]],
                    to_metadata_key:['to_metadata_key','To metadata key',[],[this.notBlankValidation]],
                },
                get_indexed_metadata:{
                    from_metadata_key:['from_metadata_key','From metadata key',[],[this.notBlankValidation]],
                    index:['value_input_num','Index',[],[this.notBlankValidation]], // Sadece sayı inputu alır
                    to_metadata_key:['to_metadata_key','To metadata key',[this.deleteBlankValidation],[]],
                    to_data_key:['to_data_key','To data key', [this.deleteBlankValidation],[]],
                },
                add_to_data:{
                    value:['value_input','Value',[],[this.notBlankValidation]],
                    eval:['value_input_bool','Evaluate input',[],[]],
                    type:['type_input','Value type',[],[]],
                    to_data_key:['to_data_key','To data key',[],[this.notBlankValidation]],
                },
                add_to_data_from_metadata:{
                    from_metadata_key:['from_metadata_key','From metadata key',[],[this.notBlankValidation]],
                    to_data_key:['to_data_key','To data key',[],[this.notBlankValidation]],
                },
                get_saved_metadata:{
                    key:['value_input_str','Key',[],[this.notBlankValidation]],
                    to_metadata_key:['to_metadata_key','To metadata key',[this.deleteBlankValidation],[]],
                    to_data_key:['to_data_key','To data key',[this.deleteBlankValidation],[]],
                },
                split_string:{
                    from_metadata_key:['from_metadata_key','From metadata key',[this.deleteBlankValidation],[]],
                    split_char:['value_input_str','Split from',[],[this.notBlankValidation]], // Sadece str input alır
                    in_two:['value_input_bool','In two',[],[]], // Sadece boolean input alır
                    get_index:['value_input_num','Get index',[this.deleteBlankValidation],[]],
                    to_metadata_key:['to_metadata_key','To metadata key',[this.deleteBlankValidation],[]],
                    to_data_key:['to_data_key','To data key',[this.deleteBlankValidation],[]],
                },
                sub_string:{
                    from_metadata_key:['from_metadata_key','From metadata key',[this.deleteBlankValidation],[]],
                    start_str:['value_input_str','Start string',[this.deleteBlankValidation],[]],
                    eval_start_str:['value_input_bool','Evaluate start string',[],[]],
                    end_str:['value_input_str','End string',[this.deleteBlankValidation],[]],
                    eval_end_str:['value_input_bool','Evaluate end string',[],[]],
                    to_metadata_key:['to_metadata_key','To metadata key',[this.deleteBlankValidation],[]],
                    to_data_key:['to_data_key','To data key',[this.deleteBlankValidation],[]],
                },
                replace_string:{
                    from_metadata_key:['from_metadata_key','From metadata key',[this.deleteBlankValidation],[]],
                    replace_map:['value_input_map','Old - new map',[],[]],
                    to_metadata_key:['to_metadata_key','To metadata key',[this.deleteBlankValidation],[]],
                    to_data_key:['to_data_key','To data key',[this.deleteBlankValidation],[]],
                },
                clear_text:{
                    from_metadata_key:['from_metadata_key','From metadata key',[this.deleteBlankValidation],[]],
                    chars_to_clear:['value_input_list','Chars to clear',[],[],[this.caseInsensitiveListInputMappings]], // Liste olarak input alır
                    to_metadata_key:['to_metadata_key','To metadata key',[this.deleteBlankValidation],[]],
                    to_data_key:['to_data_key','To data key',[this.deleteBlankValidation],[]],
                },
                get_length:{
                    from_metadata_key:['from_metadata_key','From metadata key',[this.deleteBlankValidation],[]],
                    to_metadata_key:['to_metadata_key','To metadata key',[this.deleteBlankValidation],[]],
                    to_data_key:['to_data_key','To data key',[this.deleteBlankValidation],[]],
                },
                join_string:{
                    from_metadata_key:['from_metadata_key','From metadata key',[this.deleteBlankValidation],[]],
                    join_string:['value_input_str','Join string',[],[this.notBlankValidation]],
                    to_metadata_key:['to_metadata_key','To metadata key',[this.deleteBlankValidation],[]],
                    to_data_key:['to_data_key','To data key',[this.deleteBlankValidation],[]],
                },
                clear_duplicates:{
                    from_metadata_key:['from_metadata_key','From metadata key',[this.deleteBlankValidation],[]],
                    to_metadata_key:['to_metadata_key','To metadata key',[this.deleteBlankValidation],[]],
                    to_data_key:['to_data_key','To data key',[this.deleteBlankValidation],[]],
                },
                parse_js:{
                    from_metadata_key:['from_metadata_key','From metadata key',[this.deleteBlankValidation],[]],
                    to_metadata_key:['to_metadata_key','To metadata key',[this.deleteBlankValidation],[]],
                    to_data_key:['to_data_key','To data key',[this.deleteBlankValidation],[]],
                },
                lat_lon_from_googlemaps_url:{
                    from_metadata_key:['from_metadata_key','Google Maps url metadata key',[],[this.notBlankValidation]],
                    to_metadata_key_lat:['value_input_str', 'To metadata key latitude',[this.deleteBlankValidation],[]],
                    to_data_key_lat:['value_input_str','To data key latitude',[this.deleteBlankValidation],[]],
                    to_metadata_key_lon:['value_input_str', 'To metadata key longitude',[this.deleteBlankValidation],[]],
                    to_data_key_lon:['value_input_str','To data key longitude',[this.deleteBlankValidation],[]],
                },
                get_kml:{
                    mid:['value_input_str','MID',[this.deleteBlankValidation],[]],
                    mid_metadata_key:['value_input_str','MID metadata key',[this.deleteBlankValidation],[]],
                    to_metadata_key:['to_metadata_key','To metadata key',[this.deleteBlankValidation],[]],
                    to_data_key:['to_data_key','To data key',[this.deleteBlankValidation],[]],
                },
                geocode:{
                    geocode_str:['value_input_str','Geocode string',[],[this.notBlankValidation]],
                    geocode_method:['value_input_choices','Geocode service',[],[this.notBlankValidation],[this.geocodeMethodChoices]],
                    to_metadata_key_lat:['value_input_str', 'To metadata key latitude',[this.deleteBlankValidation],[]],
                    to_data_key_lat:['value_input_str','To data key latitude',[this.deleteBlankValidation],[]],
                    to_metadata_key_lon:['value_input_str', 'To metadata key longitude',[this.deleteBlankValidation],[]],
                    to_data_key_lon:['value_input_str','To data key longitude',[this.deleteBlankValidation],[]],
                    to_metadata_key_confidence:['value_input_str', 'To metadata key confidence',[this.deleteBlankValidation],[]],
                    to_data_key_confidence:['value_input_str','To data key confidence',[this.deleteBlankValidation],[]],
                },
                url_encode:{
                    from_metadata_key:['from_metadata_key','From metadata key',[],[this.notBlankValidation]],
                    to_metadata_key:['to_metadata_key','To metadata key',[this.deleteBlankValidation],[]],
                    to_data_key:['to_data_key','To data key',[this.deleteBlankValidation],[]],
                },
                url_decode:{
                    from_metadata_key:['from_metadata_key','From metadata key',[],[this.notBlankValidation]],
                    to_metadata_key:['to_metadata_key','To metadata key',[this.deleteBlankValidation],[]],
                    to_data_key:['to_data_key','To data key',[this.deleteBlankValidation],[]],
                },
                cross_join:{
                    keys:['value_input_list','Cross join parameters',[],[],[null]],
                    join_string:['value_input_str','Join string',[],[this.notBlankValidation]],
                    to_metadata_key:['to_metadata_key','To metadata key',[this.deleteBlankValidation],[]],
                    to_data_key:['to_data_key','To data key',[this.deleteBlankValidation],[]],
                },
                paginate_links:{
                    url:['value_input_str','Base URL',[this.deleteBlankValidation],[]],
                    page_query:['value_input_str','Page query',[this.deleteBlankValidation],[]],
                    paging_method:['value_input_choices','Paging method',[this.deleteBlankValidation],[],[this.paginateChoices]],
                    page_count:['value_input_num','Page count',[this.deleteBlankValidation],[]],
                    element_count:['value_input_num','Element count',[this.deleteBlankValidation],[]],
                    element_per_page:['value_input_num','Element per page',[this.deleteBlankValidation],[]],
                    page_index_start:['value_input_num','Page index start',[this.deleteBlankValidation],[]],
                    page_index_increment:['value_input_num','Page index increment',[this.deleteBlankValidation],[]],
                    to_metadata_key:['to_metadata_key', 'To metadata key',[this.deleteBlankValidation],[]],
                    to_data_key:['to_data_key','To data key',[this.deleteBlankValidation],[]],
                },
                sleep:{
                    seconds_metadata_key:['from_metadata_key','Seconds to sleep (from metadata key)',[this.deleteBlankValidation],[]],
                    seconds:['value_input_num','Seconds to sleep',[this.deleteBlankValidation],[]],
                    to_metadata_key:['to_metadata_key', 'To metadata key',[this.deleteBlankValidation],[]],
                    to_data_key:['to_data_key','To data key',[this.deleteBlankValidation],[]],
                },

                // SoupParser
                get_with_css_selector:{
                    from_metadata_key:['from_metadata_key','From metadata key',[this.deleteBlankValidation],[]],
                    selector:['value_input_str','Selector',[],[this.notBlankValidation]], // selector validator
                    multiple:['value_input_bool','Multiple',[this.deleteBlankValidation],[]],
                    exclude_child:['value_input_bool','Exclude children',[this.deleteBlankValidation],[]],
                    to_metadata_key:['to_metadata_key', 'To metadata key',[this.deleteBlankValidation],[]],
                    to_data_key:['to_data_key','To data key',[this.deleteBlankValidation],[]],
                },
                get_items_with_css_selector:{
                    from_metadata_key:['from_metadata_key','From metadata key',[this.deleteBlankValidation],[]],
                    selector_key_relations:['value_input_map','Selector - key relations',[],[]],
                    to_metadata_key:['to_metadata_key', 'To metadata key',[this.deleteBlankValidation],[]],
                    to_data_key:['to_data_key','To data key',[this.deleteBlankValidation],[]],
                },
                get_attribute:{
                    from_metadata_key:['from_metadata_key','From metadata key',[],[this.notBlankValidation]],
                    attribute_name:['value_input_str','Attribute name',[],[this.notBlankValidation]],
                    to_metadata_key:['to_metadata_key', 'To metadata key',[this.deleteBlankValidation],[]],
                    to_data_key:['to_data_key','To data key',[this.deleteBlankValidation],[]],
                },
                get_text:{
                    from_metadata_key:['from_metadata_key','From metadata key',[],[this.notBlankValidation]],
                    to_metadata_key:['to_metadata_key', 'To metadata key',[this.deleteBlankValidation],[]],
                    to_data_key:['to_data_key','To data key',[this.deleteBlankValidation],[]],
                },

                // JSONParser
                get_json_field:{
                    from_metadata_key:['from_metadata_key','From metadata key',[this.deleteBlankValidation],[]],
                    json_key:['value_input','JSON key',[],[this.notBlankValidation]],
                    to_metadata_key:['to_metadata_key', 'To metadata key',[this.deleteBlankValidation],[]],
                    to_data_key:['to_data_key','To data key',[this.deleteBlankValidation],[]],
                },
                get_items_from_json_list:{
                    from_metadata_key:['from_metadata_key','From metadata key',[this.deleteBlankValidation],[]],
                    field_key_relations:['value_input_map','Field - key relations',[],[]], // özel validation
                    to_metadata_key:['to_metadata_key', 'To metadata key',[this.deleteBlankValidation],[]],
                    to_data_key:['to_data_key','To data key',[this.deleteBlankValidation],[]],
                },
                get_json_values:{
                    from_metadata_key:['from_metadata_key','From metadata key',[this.deleteBlankValidation],[]],
                    to_metadata_key:['to_metadata_key', 'To metadata key',[this.deleteBlankValidation],[]],
                    to_data_key:['to_data_key','To data key',[this.deleteBlankValidation],[]],
                },
                get_json_keys:{
                    from_metadata_key:['from_metadata_key','From metadata key',[this.deleteBlankValidation],[]],
                    to_metadata_key:['to_metadata_key', 'To metadata key',[this.deleteBlankValidation],[]],
                    to_data_key:['to_data_key','To data key',[this.deleteBlankValidation],[]],
                },
            }
        },
    }
}
</script>

<style>

.action-line .row{
    gap:10px;
}

.validation-error {
    font-weight: 400px;
    color:red;
}

</style>